export const DEFAULT_PATH = "*";
export const LOGIN_PATH = "/login";
export const REGISTER_PATH = "/register";
export const BAKELI_CALLBACK_PATH = "/auth/callback";

export const ACCUEIL_PATH = "/accueil";

export const SCORE_PATH = "/score";
export const QUIZZ_PLAY_PATH = "/quizplay";
export const NIVEAU_PATH = "/niveau";
export const GAME_ZONE_PATH = "/game_zone";
export const BOOKMARKS_PATH = "/bookmarks";

export const PRATIQUE_PATH = '/pratique'
export const PRATIQUE_EDITOR_PATH = '/pratique/:languageId/:levelId';

export const CORRECTION_PATH = '/correction'

export const STATISTIQUE_PATH = "/statistique";

export const CODING_SPACE_PATH = "/coding";

export const COMPILATEUR = "/compile";
export const RECOMMENDATION_PATH = "/recommendation";
export const CHALLENGE_PATH = "/challenge";
export const CHALLENGE_ZONE_PATH = "/challenge_zone";

export const WEB_ZONE_PATH = "/web_zone";

export const TESTER_NIVEAU_PATH = "/tester_niveau";

export const ACCUEIL_TEST = "/accueil_test";

export const HOME = "/home";
export const RESET_PASSWORD = "/reset_password";
export const RESET_CONFIRM_PASSWORD = "/password/reset/confirm/:uid/:token";
export const ACTIVATE = "/activate/:uid/:token";

export const TEST_DETAIL = "/test_detail";

export const CHALLENGE_CORRECTION_PATH = "/challenge_correction";
export const CHOIX_LANGAGE_PATH = "/choix_langage";
export const EXERCICE_ZONE_PATH = "/exercice_zone";

// Admin Paths
export const ADMIN_DASHBOARD_PATH = "/admin";
export const ADD_QUESTION_PATH = "/admin/addQuestion";
export const ADD_CATEGORY_PATH = "/admin/addCategory";
export const ADD_PARCOUR_PATH = "/admin/addParcours";

// Coach Paths
export const COACH_DASHBOARD_PATH = "/coach/dashboard";
export const COACH_QUESTIONS_PATH = "/coach/questions";
export const COACH_EXERCISES_PATH = "/coach/exercises";
export const COACH_LEADERBOARD_PATH = "/coach/leaderboard";
